import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import styled from 'styled-components'
import Img from 'gatsby-image'
import parse from 'html-react-parser'
import { colors } from '../components/Colors'
import { device } from '../components/Breakpoints'
import { Breadcrumb } from '../components/Breadcrumb'
import FotosSlider from '../components/FotosSlider'
import imgBola from '../img/gravida-exercicio-2.jpg'
import iconBalanço from '../icons/icon-balanco.svg'
import iconBanheira from '../icons/icon-banheira.svg'
import iconBanqueta from '../icons/icon-banqueta.svg'
import iconBarra from '../icons/icon-barra.svg'
import iconBola from '../icons/icon-bola.svg'
import PageHeader from '../components/PageHeader'
import Layout from '../components/Layout'
import VejaTambem from '../components/VejaTambem'
import CentralAtendimento from '../components/CentralAtendimento'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
`

const GroupContent = styled.section`
  padding: 2em 0;
  @media ${device.mobileL} {
    padding: 2em;
    p,
    h3 {
      text-align: left;
    }
  }

  .inner {
    display: flex;
    justify-content: space-between;
    @media ${device.mobileL} {
      flex-wrap: wrap;
    }
  }

  .comodidades {
    p {
      @media ${device.mobileL} {
        text-align: center;
      }
    }
    .list {
      border-bottom: 6px #fff solid;
      border-left: 6px #fff solid;
      border-right: 6px #fff solid;
      padding: 1.5em;
      margin: 0 -2em;
      position: relative;
      :before {
        content: '';
        background: #ffffff;
        width: 2%;
        height: 6px;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
      }
      @media ${device.mobileL} {
        margin: 0 2em;
        border-top: 8px #ffffff solid;
        border-left: 8px #ffffff solid;
        border-right: 8px #ffffff solid;
        border-bottom: none;
        display: block;
        padding: 2em 2em;
        :before {
          content: '';
          background: #ffffff;
          width: 15px;
          height: 8px;
          position: absolute;
          left: -1px;
          bottom: 0;
          top: inherit;
          z-index: 2;
        }
        :after {
          content: '';
          background: #ffffff;
          width: 60px;
          height: 8px;
          position: absolute;
          right: -1px;
          bottom: 0;
          top: inherit;
          z-index: 2;
        }
      }
      h3 {
        margin-top: -50px;
        font-size: 1em;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        div.title {
          max-width: 575px;
        }
        :after {
          content: '';
          background: #ffffff;
          height: 6px;
          flex-grow: 1;
          margin: 20px -30px 0px 10px;
        }
        @media ${device.mobileL} {
          margin-top: 0px;
          :after {
            display: none;
          }
        }
      }
      .items {
        display: flex;
        justify-content: space-between;
        @media ${device.mobileL} {
          flex-wrap: wrap;
          margin: 0;
        }
        img {
          width: 50px;
          min-height: 70px;
          display: block;
          margin: 2em auto;
        }
        div {
          width: 200px;
          background: #ffffff;
          color: #4a4a4a;
          font-size: 0.6em;
          text-align: center;
          padding: 1em 1em 2em;
          box-sizing: border-box;
          box-shadow: 1px 1px 10px #516d6e;
          :nth-child(4) {
            img {
              max-height: 60px;
              width: 40px;
              @media ${device.mobileL} {
                min-height: 100px;
                width: 120px;
              }
            }
          }
          @media ${device.mobileL} {
            width: 100%;
            margin: 0 0 1em 0;
            img {
              width: 30%;
            }
          }
        }
      }
    }
  }
  strong {
    color: ${colors.lilas};
  }
  .title {
    color: ${colors.verde};
  }

  :nth-of-type(2) {
    h3 {
      color: #8e8fc7;
    }
  }
  :nth-of-type(3) {
    background: ${colors.verdeGradiente};
    color: #ffffff;
  }
  :nth-of-type(4) {
    padding: 3em 0;
    background-color: #8accb7;
    color: #ffffff;
  }
  :nth-of-type(5) {
    background: ${colors.lilasGradiente};
    color: #ffffff;
    flex-wrap: wrap;
    h3 {
      width: 100%;
    }
    .inner {
      flex-wrap: wrap;
      > div {
        width: 50%;
        @media ${device.mobileL} {
          width: 100%;
        }
      }

      > div:last-child {
        width: 46%;
        @media ${device.mobileL} {
          width: 100%;
        }
      }
    }
    strong {
      color: ${colors.amarelo};
    }
  }
  :nth-of-type(6) {
    background: ${colors.verdeGradiente};
    color: #ffffff;
    .inner {
      > div {
        width: 100%;
        margin: auto;
      }
    }
  }
`
export const CentrodePartoNormalTemplate = ({
  title,
  content,
  image,
  slug,
  color,
  area = 'Centros e Serviços',
  galeria,
  sessoes,
}) => {
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: '#', title: area, icon: true },
    {
      id: 3,
      link: slug,
      title,
    },
  ]
  const fotosContent = [{ id: 1, image: imgBola, title: 'Bola suíça' }]

  return (
    <>
      <Container>
        <Breadcrumb crumbs={crumbs} />
        <PageHeader
          title={title}
          content={content}
          image={image}
          color={color}
          height="204px"
        />
        <GroupContent>
          <div className="inner center">
            <div>
              <h3>{parse(sessoes[0].tituloDaSessao)}</h3>
              {parse(sessoes[0].texto)}
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner center">
            <div>
              <h3>{parse(sessoes[1].tituloDaSessao)}</h3>
              {parse(sessoes[1].texto)}
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="comodidades center">
            <div className="list">
              <h3>
                <div className="title">
                  Os apartamentos contam com aparelhos para exercícios e outros
                  equipamentos que auxiliam na recuperação como:
                </div>
              </h3>
              <div className="items">
                <div>
                  <img src={iconBanheira} alt="Cama" />
                  Banheira integrada ao quarto com cromoterapia
                </div>
                <div>
                  <img src={iconBola} alt="Armários" />
                  Bola suiça
                </div>
                <div>
                  <img src={iconBarra} alt="Sofá" />
                  Barra de alongamento
                </div>
                <div>
                  <img src={iconBalanço} alt="TV a cabo" />
                  Balanço pélvico tipo &quot;cavalinho&quot;
                </div>
                <div>
                  <img src={iconBanqueta} alt="Frigobar" />
                  Banqueta de parto
                </div>
              </div>
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner center">
            <h3>{parse(sessoes[2].tituloDaSessao)}</h3>
            <div>{parse(sessoes[2].texto)}</div>
            {sessoes[2].imagemDaSessao.localFile ? (
              <Img
                fluid={
                  sessoes[2].imagemDaSessao.localFile.childImageSharp.fluid
                }
                alt="Bola suíça"
              />
            ) : (
              <img src={sessoes[2].imagemDaSessao.sourceUrl} alt="Bola suíça" />
            )}
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner center">
            <div>
              <h4>Fotos</h4>
              <FotosSlider fotos={galeria} />
            </div>
          </div>
        </GroupContent>

        <CentralAtendimento />
      </Container>
    </>
  )
}

CentrodePartoNormalTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

const CentrodePartoNormal = ({ data, location }) => {
  const { siteMetadata: site } = data.site
  const { wpPage: page } = data
  const image = page.opEsDaPGina.imagem ? page.opEsDaPGina.imagem.sourceUrl : ''
  const area = location.state ? location.state.area : page.opEsDaPGina.area
  const { paginasRelacionadas } = page.opEsDaPGina
  const { sessaoCustomizada: sessoes } = page.SessoesCustomizadas
  const { galeria } = page.galeria
  const description = page.excerpt
    ? page.excerpt.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
    : ''

  return (
    <Layout title={`${page.title} – ${site.title}`} description={description}>
      <CentrodePartoNormalTemplate
        title={page.title}
        content={page.content}
        image={image}
        slug={page.slug}
        color={page.opEsDaPGina.corDoCabecalho}
        area={area}
        galeria={galeria}
        sessoes={sessoes}
      />

      <VejaTambem relatedPages={paginasRelacionadas} />
    </Layout>
  )
}

CentrodePartoNormal.propTypes = {
  data: PropTypes.object.isRequired,
}

export default CentrodePartoNormal

export const CentrodePartoNormalQuery = graphql`
  query CentrodePartoNormalById($id: String!) {
    site {
      siteMetadata {
        url
        title
      }
    }
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      SessoesCustomizadas {
        sessaoCustomizada {
          texto
          tituloDaSessao
          imagemDaSessao {
            sourceUrl
            localFile {
              childImageSharp {
                fluid(quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
      galeria {
        galeria {
          id
          altText
          title
          sourceUrl
        }
      }
      opEsDaPGina {
        corDoCabecalho
        area
        imagem {
          sourceUrl
        }
        paginasRelacionadas {
          ... on WpPage {
            id
            title
            slug
          }
        }
      }
    }
  }
`
